import React from "react";
import "./ServicePages.scss";

//Panels
import Hero from "./Components/Hero";

//Images
import patiosBg from "./images/patios/bg-patios.jpg";
import featureA1 from "./images/patios/feature-a-1.jpg";
import featureA2 from "./images/patios/feature-a-2.jpg";
import featureA3 from "./images/patios/feature-a-3.jpg";
import featureB1 from "./images/patios/feature-b-1.jpg";
import featureB2 from "./images/patios/feature-b-2.jpg";
import featureB3 from "./images/patios/feature-b-3.jpg";
import featureC1 from "./images/patios/feature-c-1.jpg";
import featureC2 from "./images/patios/feature-c-2.jpg";
import featureC3 from "./images/patios/feature-c-3.jpg";
import stone1 from "./images/patios/Estate-Cobble-I-II-Cream-Terracotta-Brown.jpg";
import stone2 from "./images/patios/Mirage_Silverlake_Resia_0.jpg";
import stone3 from "./images/patios/Slaton-Gray-Moss-Charcoal.jpg";

//SEO
import SEO from "../../../SEO/index.js";
import StructuredData from "../../../SEO/structuredData";

const Patios = () => {
  return (
    <>
      <SEO
        title="Outdoor Patio Pavers | Los Angeles | Pacific Pavingstone"
        description="Beautify your outdoor entertaining area with patio paving. We offer concrete pavers, natural stone pavers, and porcelain landscape tiles. Get started today!"
        profileURL={"https://www.pacificpavingstone.com/services/patios"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "Service",
          name: "Outdoor Patio Pavers",
          image:
            "https://www.pacificpavingstone.com/static/media/bg-patios.e2c9051a.jpg",
          description:
            "Beautify your outdoor entertaining area with patio paving. We offer concrete pavers, natural stone pavers, and porcelain landscape tiles. Get started today!",
          brand: "Pacific Pavingstone",
          areaServed: "Southern California",
          logo: "https://www.pacificpavingstone.com/static/media/logo-2.bf1f43f9.png",
          provider: "Pacific Pavingstone",
          URL: "https://www.pacificpavingstone.com/services/patios",
          potentialAction: "Schedule a Consultation",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5",
            bestRating: "5",
            worstRating: "1",
            ratingCount: "1",
            reviewCount: "1",
          },
          review: {
            "@type": "Review",
            name: "S.B.",
            reviewBody:
              "I highly recommend Pacific Pavingstone for any paving job. They recently added a beautiful patio of pavers to our backyard and we couldn't be happier with the result. Craig came out to give us an estimate for our small job and spent a considerable amount of time with us, going over all our options. His team even dropped off some sample pavers when we couldn't decide what color to go with so we could see it in-place. Onecimo and his crew were awesome and made sure we were happy as the job progressed. No detail was too small for them to take the time to do it right and make sure it looked good. They left the job site clean at the end of every day and were very professional. They also started and finished the job in the exact timeframe they said they would.",
            reviewRating: {
              "@type": "Rating",
              ratingValue: "5",
              bestRating: "5",
              worstRating: "1",
            },
            datePublished: "2021-10-08",
            author: { "@type": "Person", name: "S.B." },
            publisher: { "@type": "Organization", name: "Pacific Pavingstone" },
          },
        }}
      />
      <div className="container-fluid page-featured">
        <Hero title={"Patios"} background={patiosBg} />
        <div className="row justify-content-center">
          <div className="col-11 col-md-9">
            <div className="row justify-content-center panel-content pb-4">
              <div className="col-12">
                <p>
                  Undertaking a patio renovation requires some careful
                  consideration and deliberation. The materials you choose for
                  your patio can make or break your outdoor space. They have to
                  a mixture of durable, aesthetically pleasing and economical.
                  Before you break ground on your next project, take a look at
                  the most common patio paver options.
                </p>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Concrete Pavers
                </h2>
                <p>
                  Concrete pavers are created by pouring concrete into molds,
                  adding dye to mimic natural stones or improve the visual
                  appeal, and incorporating varieties of textures and finishes.
                  These man-made pavers can adopt a wide range of shapes, sizes,
                  and colors. Laying Concrete Pavers in different patterns forms
                  focal points on your patio floor and can compliment fire pits,
                  retaining walls and steps made from the same materials.
                  Concrete pavers are also durable, long lasting and need
                  minimal maintenance.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureA3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Natural Stone Pavers
                </h2>
                <p>
                  Natural Stone Pavers is an umbrella term that covers a wide
                  range of materials from flagstone and granite to travertine.
                  With their rich, earthy tones, Natural Stone Pavers lend
                  themselves to a rustic, natural look but are timeless enough
                  to also thrive in contemporary designs. Each stone is unique
                  and have slight variations in color, texture and style. They
                  can be incorporated into your design to harmonize with the
                  surrounding landscape to create an organic beauty. These
                  high-quality pavers are low maintenance pavers, involving
                  regular sweeping and rinsing and get more rustic with age.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureB3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12">
                <h2 className="text-center text-uppercase mb-4">
                  Porcelain Landscape Tiles
                </h2>
                <p>
                  Porcelain pavers are a very popular paving option. Porcelain
                  Pavers lend themselves to an elegant and sophisticated
                  aesthetic that goes great with modern, contemporary and
                  traditional design. They are a costly option but offer
                  durability and a high fashion aesthetic. Available in a
                  variety of styles and shapes, Porcelain Pavers can mimic the
                  look and feel of wood or stone tiles with the durability and
                  flexibility of paving stones. If you are looking for a
                  sure-fire way to elevate your patio, porcelain pavers are the
                  choice for you.
                </p>
              </div>
              <div className="col-12 mt-5">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureC1}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureC2}
                      alt="Featured"
                    />
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <img
                      className="mb-2 mb-lg-0"
                      src={featureC3}
                      alt="Featured"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center panel-content">
              <div className="col-12 mt-4">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={stone3}
                        alt="Angelus Slaton Random In Gray-Moss-Sharcoal"
                      />
                      <div className="text">
                        <p>
                          Angelus Slaton Random
                          <br />
                          In Gray-Moss-Sharcoal
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={stone1}
                        alt="Angelus Estate Cobble I & II In Cream Terracotta Brown"
                      />
                      <div className="text">
                        <p>
                          Angelus Estate Cobble I &amp; II
                          <br />
                          In Cream Terracotta Brown
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-4">
                    <div className="image-style mb-2 mb-lg-0">
                      <img
                        src={stone2}
                        alt="Belgard Silverlake Porcelain Paver In Resia"
                      />
                      <div className="text">
                        <p>
                          Belgard Silverlake Porcelain Paver
                          <br />
                          In Resia
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Patios;
